import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import "./styles/tailwind.css";
import "./styles/index.css";
import deepsearchService from "./services/deepsearchService";
import networkAudit from "./utils/networkAudit";
import NetworkAuditOverlay from "./components/NetworkAuditOverlay";

// Make the global attach happen BEFORE React mounts
if (typeof window !== "undefined") {
  window.deepsearchService = deepsearchService;

  // Extract prototype methods, excluding the constructor
  const proto = Object.getPrototypeOf(deepsearchService);
  const methods = Object.getOwnPropertyNames(proto)
    .filter(k => typeof deepsearchService[k] === "function" && k !== "constructor");

  window.deepsearchService._debug = {
    name: "deepsearchService",
    version: "1.0",
    methods
  };

  // Network audit for dev (egress debugging)
  if (import.meta.env.DEV) {
    window.networkAudit = networkAudit;
    console.log('🔍 Network audit available: networkAudit.start(), .stop(), .print(), .status(), .clear()');
    
    // Auto-start if configured
    if (import.meta.env.VITE_NETWORK_AUDIT === 'true') {
      // Wait for DOM to be ready
      setTimeout(() => {
        networkAudit.start();
        console.log('🔍 Network audit auto-started (VITE_NETWORK_AUDIT=true)');
      }, 100);
    }
  }
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
      {/* Dev-only network audit overlay */}
      {import.meta.env.DEV && import.meta.env.VITE_NETWORK_AUDIT_OVERLAY === 'true' && (
        <NetworkAuditOverlay />
      )}
    </AuthProvider>
  </React.StrictMode>
);
